module.exports = __webpack_public_path__ + "img/gq15.4c45533e.png";